<script setup lang="ts">
import { computed, toRef } from 'vue'
import type { Praeparat } from '@/types/otc/praeparat'
import {useDictionaryLabels} from "@/vue_components/praeparate/composables/useDictonaryLabels";
import {useDropdownBehavior} from "@/vue_components/praeparate/composables/useDropdownBehavior";
import { productService } from '@/api/product.service';
import { SearchHistory } from '@/classes/searchHistory';
import SearchHistoryService from '@/services/searchHistoryService';

interface Props {
  productName: string
  selected: Praeparat
  praeparatList: Praeparat[]
  dictionary: Record<string, string>
}

const props = defineProps<Props>()
const emit = defineEmits<{ (e: 'select', value: Praeparat): void }>()

const dictionaryRef = toRef(props, 'dictionary')
const { labels } = useDictionaryLabels(dictionaryRef)
const { show, toggle, close } = useDropdownBehavior()

const nonSelected = computed(() =>
    props.praeparatList.filter(p => p.id !== props.selected.id)
)

function shortPraeparatName(full: string | undefined | null): string {
  if (!full) return ''
  const reg = new RegExp(`^${props.productName}\\s*`, 'i')
  return full.replace(reg, '').trim()
}

async function choose(p: Praeparat) {
  emit('select', p)
  const url = await productService.getPraeparatUrl(p.produktId, p.id);
  setSearchHistory(p.id.toString());
  window.location.href = url;
}
async function setSearchHistory(id:string){
    const searchHistory = new SearchHistory({
        historyType: "praeparat",
        id: id
    })
    SearchHistoryService.Instance.setSearchHistory(searchHistory);
}
</script>

<template>
  <div v-if="nonSelected.length" class="praeparat-dropdown">
    <p class="produkte-label">
      {{ labels.wirkstaerkenDarreichungsformen }}
    </p>

    <div class="dropdown dropdown-praeparate multiple" @keyup.esc="close">
      <div class="dropdown-selected" @click.prevent="toggle">
        <span>
          <strong>{{ productName }} {{ shortPraeparatName(selected.name) }}</strong>
        </span>
      </div>

      <ul class="dropdown-list" :class="{ visible: show }">
        <li
            v-for="praep in nonSelected"
            :key="praep.id"
            @click.prevent="choose(praep)"
        >
          {{ praep.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
</style>